import {
  TIMEOFFSET_SPECIFIC_TIME,
  TIMEOFFSET_SPECIFIC_AUTOMATION_TIME,
  DATEOFFSET_ON_DAY,
} from 'pages/AutomationEngine/helpers';

export const SA_TYPE_ROUND_ROBIN_ALL = 'round_robin_all';
export const SA_TYPE_ROUND_ROBIN_ROLE = 'round_robin_role';
export const SA_TYPE_ROUND_ROBIN_TEAM_MEMBERS = 'round_robin_team_members';
export const SA_TYPE_TEAM_MEMBER = 'team_member';
export const SA_TYPE_TEAM_MEMBER_FIELD = 'team_selector_field';
export const SA_TYPE_LAST_ACTIVE_TEAM_MEMBER = 'last_active';
export const SA_TYPE_LAST_ACTIVE_TEAM_MEMBER_SPEC_ROLE = 'last_active_role';
export const SA_TYPE_SPEC_ROLE = 'specific_role';
export const SA_TYPE_OWNER = 'owner';

export const TIMEOFFSET_VALUE_MIN = 1;
export const TIMEOFFSET_VALUE_MAX = 60;
export const DELAYCHANGE_VALUE_MIN = 1;
export const DELAYCHANGE_VALUE_MAX = 180;
export const DATEOFFSET_VALUE_MIN = 1;
export const DATEOFFSET_VALUE_MAX = 365;

export const assignToTypeOptionsTranslated = (
  t,
  contextIsCustomObject = true
) =>
  [
    {
      label: t('Round Robin (Team Member of Any Role)'),
      value: SA_TYPE_ROUND_ROBIN_ALL,
    },
    {
      label: t('Round Robin (Team Member of Specific Role)'),
      value: SA_TYPE_ROUND_ROBIN_ROLE,
    },
    {
      label: t('Round Robin (Select Team Members)'),
      value: SA_TYPE_ROUND_ROBIN_TEAM_MEMBERS,
    },
    contextIsCustomObject && {
      label: t('Owner'),
      value: SA_TYPE_OWNER,
    },
    {
      label: t('Specific Team Member'),
      value: SA_TYPE_TEAM_MEMBER,
    },
    {
      label: t('Custom Team Selector Field'),
      value: SA_TYPE_TEAM_MEMBER_FIELD,
    },
    {
      label: t('Last Active Team Member (Any Role)'),
      value: SA_TYPE_LAST_ACTIVE_TEAM_MEMBER,
    },
    {
      label: t('Last Active Team Member (Specific Role)'),
      value: SA_TYPE_LAST_ACTIVE_TEAM_MEMBER_SPEC_ROLE,
    },
    {
      label: t('Specific Role'),
      value: SA_TYPE_SPEC_ROLE,
    },
  ].filter(Boolean);

export const dictionaryAssignToTypeOptionsTranslated = (t) =>
  assignToTypeOptionsTranslated(t).reduce(
    (acc, { label, value }) => ({
      ...acc,
      [value]: { value, label },
    }),
    {}
  );

export const defaultWithDelay = {
  delayType: null, // Can be minute, hour or day
  delayValue: DELAYCHANGE_VALUE_MIN,
  timeOffset: TIMEOFFSET_SPECIFIC_AUTOMATION_TIME,
  timeOffsetValue: TIMEOFFSET_VALUE_MIN,
};

export const defaultOnOrAroundDateTimeOffset = {
  time: null,
  timeOffsetValue: TIMEOFFSET_VALUE_MIN,
  timeFieldId: null,
};

export const defaultOnOrAroundDateDateOffset = {
  dateOffset: DATEOFFSET_ON_DAY, // Can be on_day, on_day_and_time, days_before or days_after
  dateOffsetDays: DATEOFFSET_VALUE_MIN,
  timeOffset: TIMEOFFSET_SPECIFIC_TIME,
  ...defaultOnOrAroundDateTimeOffset,
};

export const defaultOnOrAroundDate = {
  fieldId: null,
  ...defaultOnOrAroundDateDateOffset,
};
